"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtifactLinkProvider = void 0;
exports.useOpenArtifact = useOpenArtifact;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ArtifactLinkContext = /*#__PURE__*/(0, _react.createContext)(null);
var ArtifactLinkProvider = exports.ArtifactLinkProvider = function ArtifactLinkProvider(_ref) {
  var openArtifact = _ref.openArtifact,
    children = _ref.children;
  var value = (0, _react.useMemo)(function () {
    return {
      openArtifact: openArtifact
    };
  }, [openArtifact]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ArtifactLinkContext.Provider, {
    value: value,
    "data-sentry-element": "ArtifactLinkContext.Provider",
    "data-sentry-component": "ArtifactLinkProvider",
    "data-sentry-source-file": "ArtifactLinkContext.tsx",
    children: children
  });
};
function useOpenArtifact() {
  var ctx = (0, _react.useContext)(ArtifactLinkContext);
  if (!ctx) {
    throw new Error("useOpenArtifact must be used within ArtifactLinkProvider");
  }
  return ctx.openArtifact;
}